import React, { useMemo, useRef } from 'react';
import { Route, Routes } from 'react-router';
import { NotFoundPage } from './Common';
import { Box, styled } from '@mui/material';
import { ProvideRecipients, ProvidePreconfiguredFetch, useAuth } from '../hooks';
import { LoginPaper } from './Login';
import { LicenseInfo } from '@mui/x-license-pro';
import { ProvideSnackBar } from '../hooks/useSnackBar';
import { SMSSenderPage } from './SMSSenderPage';
import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Props } from '../@types';

const MUI_LICENSE_KEY = process.env.REACT_APP_MUI_LICENSE_KEY || 'not known';

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

const StyledApp = styled(Box)`
    background-image: url('/images/brb_logo_vertical_white.svg');
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 40%;
    min-height: 100%;
    height: 100%;
`;

const HR_GRAPHQL_ENDPOINT = process.env.REACT_APP_HR_GRAPHQL_ENDPOINT;

const httpLink = createHttpLink({
    uri: HR_GRAPHQL_ENDPOINT,
});

const ApolloApp = ({ children }: Props) => {
    const { refreshTheToken } = useAuth();
    const refreshRef = useRef(refreshTheToken);
    refreshRef.current = refreshTheToken;

    const client = useMemo(() => {
        const authLink = setContext(async (_, { headers }) => {
            const token = await refreshRef.current();
            return {
                headers: {
                    ...headers,
                    authorization: token ? `Bearer ${token}` : '',
                },
            };
        });

        return new ApolloClient({
            link: authLink.concat(httpLink),
            cache: new InMemoryCache(),
        });
    }, []);

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

function App() {
    return (
        <StyledApp>
            <ProvidePreconfiguredFetch>
                <ApolloApp>
                    <ProvideSnackBar>
                        <ProvideRecipients>
                            <Routes>
                                <Route path='/' element={<SMSSenderPage />} />
                                <Route path='/login' element={<LoginPaper />} />
                                <Route path='*' element={<NotFoundPage />} />
                            </Routes>
                        </ProvideRecipients>
                    </ProvideSnackBar>
                </ApolloApp>
            </ProvidePreconfiguredFetch>
        </StyledApp>
    );
}

export default App;
